import * as DatasetHelper from '../dataset-helper';

/**
 * Utility method to determine if the value is a scalar or a property. A property value must be
 * encapsulated by '${}'
 */
function isProperty(value) {
  return value && (typeof value === 'string') && value.startsWith('${') && value.endsWith('}');
}

/**
 * Utility method to return the property name from the value.
 */
function getProperty(value) {
  return value.substring(2, value.length - 1);
}

/**
 * Perform {@code Sum} based on the configuration.
 */
export default function calculate(statistics, dataset, categoryFieldId, calculationStepDefn) {

  // Category-level calculation.

  const categoryField = DatasetHelper.findField(dataset, categoryFieldId);
  const { categories } = categoryField;
  let total = 0;
  categories.forEach((category) => {
    const categoryResult = statistics[category.value];
    if (!categoryResult) {
      throw new Error(`Unable to find category results for "${category.value}"`);
    }

    // Identify the property.
    let propertyValue;
    const propertyDefn = calculationStepDefn.property;
    if (isProperty(propertyDefn)) {
      // Property.
      const fullPropertyName = getProperty(propertyDefn);
      const propertyName = fullPropertyName.substring(fullPropertyName.indexOf('.') + 1);
      propertyValue = (fullPropertyName.startsWith('category.') ?
        categoryResult[propertyName] :
        statistics[propertyName]);
    } else {
      // Scalar.
      propertyValue = propertyDefn;
    }

    total += propertyValue;

  });

  // Assign the result.
  const resultFieldName = calculationStepDefn.result;
  statistics[resultFieldName] = total;

}


// WEBPACK FOOTER //
// ./src/app/utils/calculators/sum-calculator.js